import React from 'react';

const Footer = () => {
    return (
        <div>
            <p className='text-center  bg-dark py-3 text-white'>Copy Right All Rights are Reserved</p>
        </div>
    );
};

export default Footer;